import { useAtom } from "jotai"
import { userAtom } from "../state"

export const useUserOrganization = () => {
  const [user] = useAtom(userAtom)
  return user?.organizations?.[0] ?? undefined
}